import { Flex, Text, Box, Divider } from "@mantine/core";
import { IconPackage } from "@tabler/icons-react";
import { ProductServiceType } from "@/components/shared/constants/general.const";
import ProfileCollapsibleSection from "@/components/shared/ProfileCollapsibleSection";

interface ProductsServicesTabProps {
  company: any;
  isMatchedView?: boolean;
}

export default function ProductsServicesTab({ company }: ProductsServicesTabProps) {
  const productServices = company?.productServices || [];

  const products = productServices.filter((item: any) => item.type === ProductServiceType.PRODUCT);
  const services = productServices.filter((item: any) => item.type === ProductServiceType.SERVICE);

  const renderItems = (items: any[]) => (
    <Flex gap="xl" wrap="wrap">
      {items.map((item: any, index: number) => (
        <Flex key={item.id || index} direction="column" style={{ flex: "1 1 45%", minWidth: "280px", maxWidth: "50%" }}>
          <Text size="sm" c="slate.8" fw={700} mb="xs">
            {item.name || "Untitled"}
          </Text>
          <Text size="sm" style={{ lineHeight: 1.5, wordBreak: "break-word", overflow: "hidden", textAlign: "justify" }}>
            {item.description || "N/A"}
          </Text>
        </Flex>
      ))}
    </Flex>
  );

  return (
    <ProfileCollapsibleSection
      title="Products & Services"
      icon={<IconPackage size={18} color="#ffc300" stroke={1.5} />}
    >
      <Flex direction="column" gap="lg">
        {products.length > 0 && (
          <Box>
            <Text size="md" c="slate.8" tt="uppercase" mb="sm" fw={600}>
              PRODUCTS
            </Text>
            {renderItems(products)}
          </Box>
        )}

        {products.length > 0 && services.length > 0 && <Divider />}

        {services.length > 0 && (
          <Box>
            <Text size="md" c="slate.8" tt="uppercase" mb="sm" fw={600}>
              SERVICES
            </Text>
            {renderItems(services)}
          </Box>
        )}

        {products.length === 0 && services.length === 0 && (
          <Text size="lg" c="slate.6">
            N/A
          </Text>
        )}
      </Flex>
    </ProfileCollapsibleSection>
  );
}
